export enum filtersActionTypes {
  SET_DEAL_TYPE = 'filters/setDealType',
  SET_REGION = 'filters/setRegion',
  SET_CATEGORY = 'filters/setCategory',
  SET_CHARTS_DATA = 'filters/setChartsData',
}
